import { useQueryClient } from "@tanstack/react-query";
import { Link, useRouter, useRouterState, type ErrorComponentProps } from "@tanstack/react-router";
import { CircleAlert, Construction } from "lucide-react";
import { Cabecalho, Conteudo } from "../componentes/ui";
import { TODOS_ITENS } from "../menu";

export function PaginaEmConstrucao() {
  const caminho = useRouterState({ select: (s) => s.location.pathname });
  const item = TODOS_ITENS.find((i) => i.para === caminho);
  const Icone = item?.icone ?? Construction;
  return (
    <>
      <Cabecalho titulo={item?.rotulo ?? "Em construção"} />
      <Conteudo estreito>
        <div className="cartao flex flex-col items-center gap-3 px-6 py-16 text-center">
          <div className="grid size-14 place-items-center rounded-[var(--raio)] bg-muted text-muted-foreground">
            <Icone className="size-6" />
          </div>
          <div className="font-semibold">Em construção</div>
          <p className="max-w-sm text-sm text-texto-suave">
            A tela de {item?.rotulo.toLowerCase() ?? "esta seção"} entra nas próximas entregas. O desenho de referência está no mockup v4.
          </p>
        </div>
      </Conteudo>
    </>
  );
}

/** Erro inesperado ao desenhar uma tela. Aparece no lugar da tela, com o menu à mão. */
export function PaginaErro({ error, reset }: ErrorComponentProps) {
  const roteador = useRouter();
  const consultas = useQueryClient();
  return (
    <>
      <Cabecalho titulo="Algo deu errado" />
      <Conteudo estreito>
        <div role="alert" className="cartao flex flex-col items-center gap-3 px-6 py-16 text-center">
          <CircleAlert className="size-8 text-perigo" />
          <p className="max-w-sm text-texto-suave">Esta tela encontrou um erro e não pôde ser exibida. Tente de novo; se o erro continuar, anote o detalhe abaixo e avise quem cuida do sistema.</p>
          <div className="flex flex-wrap justify-center gap-2">
            <button
              type="button"
              className="botao botao-primario"
              onClick={() => {
                // Descarta os dados guardados (podem ser a causa do erro) e redesenha; a sessão fica.
                void consultas.resetQueries({ predicate: (q) => q.queryKey[0] !== "auth" });
                reset();
                void roteador.invalidate();
              }}
            >
              Tentar de novo
            </button>
            <Link to="/" className="botao botao-secundario">
              Ir para o início
            </Link>
          </div>
          <details className="max-w-full text-left text-xs text-texto-suave">
            <summary className="cursor-pointer">Detalhe técnico</summary>
            <code className="mt-1 block break-all">{error instanceof Error ? error.message : String(error)}</code>
          </details>
        </div>
      </Conteudo>
    </>
  );
}

export function PaginaNaoEncontrada() {
  return (
    <>
      <Cabecalho titulo="Página não encontrada" />
      <Conteudo estreito>
        <div className="cartao flex flex-col items-center gap-3 px-6 py-16 text-center">
          <p className="text-texto-suave">Este endereço não existe.</p>
          <Link to="/" className="botao botao-primario">
            Ir para o início
          </Link>
        </div>
      </Conteudo>
    </>
  );
}
